import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=1797fc55&scoped=true&"
import script from "./NotFound404.vue?vue&type=script&lang=js&"
export * from "./NotFound404.vue?vue&type=script&lang=js&"
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=1797fc55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1797fc55",
  null
  
)

export default component.exports